/**
 * Resumen compacto de campos incluidos; la edición vive en SourceFieldsModal.
 */
import React from 'react';
import { studio, ink } from '../studioUi';
import { selectedColumnAlias, selectedColumnOrder } from './engineConfig';

export default function SourceColumnPicker({
    source,
    columns = [],
    onOpen,
}) {
    if (!source) return null;
    const restricted = Boolean(source.selectedColumns);
    const order = selectedColumnOrder(source, columns);
    const total = columns.length;
    const count = restricted ? order.length : total;
    const preview = (restricted ? order : columns.map((col) => col.name)).slice(0, 8);

    return (
        <div style={ui.wrap}>
            <div style={ui.head}>
                <div style={ui.titleBlock}>
                    <span style={studio.kicker}>Campos incluidos</span>
                    <span style={ui.count}>
                        {total
                            ? (restricted ? `${count} de ${total}` : `Todas · ${total}`)
                            : 'Conecta la hoja para ver columnas'}
                    </span>
                </div>
                <button
                    type="button"
                    style={ui.open}
                    disabled={!columns.length}
                    onClick={onOpen}
                >
                    Editar
                </button>
            </div>
            {preview.length > 0 ? (
                <div style={ui.chips}>
                    {preview.map((name) => (
                        <span key={name} style={ui.chip} title={name}>
                            {selectedColumnAlias(source, name)}
                        </span>
                    ))}
                    {count > preview.length ? <span style={ui.more}>+{count - preview.length}</span> : null}
                </div>
            ) : (
                <p style={ui.empty}>Aún no hay columnas. Conecta la fuente y elige cuáles incluir.</p>
            )}
        </div>
    );
}

const ui = {
    wrap: { display: 'flex', flexDirection: 'column', gap: 10 },
    head: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 },
    titleBlock: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 },
    count: { fontSize: '0.78rem', fontWeight: 650, color: ink.muted, lineHeight: 1.35 },
    empty: { margin: 0, fontSize: '0.78rem', color: ink.faint, lineHeight: 1.45 },
    chips: { display: 'flex', flexWrap: 'wrap', gap: 6 },
    chip: {
        maxWidth: 140,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '0.72rem',
        fontWeight: 600,
        color: ink.accentText,
        backgroundColor: ink.accentSoft,
        borderRadius: 999,
        padding: '4px 10px',
    },
    more: { fontSize: '0.72rem', color: ink.faint, alignSelf: 'center' },
    open: {
        appearance: 'none',
        flexShrink: 0,
        padding: '7px 14px',
        minHeight: 32,
        borderRadius: 999,
        borderWidth: 0,
        backgroundColor: ink.accent,
        color: ink.surface,
        cursor: 'pointer',
        fontSize: '0.75rem',
        fontWeight: 700,
        fontFamily: 'inherit',
    },
};
